<template>
  <slot v-bind="{items, add, remove, form}"></slot>
</template>

<script>
import {reactive} from "vue";

export default {
  name: "Repeatable",
  props: {
    model: {type: Object, required: true},
    modelValue: {type: Array, required: true},
  },
  emits: ['update:modelValue', 'add'],
  setup(props, {emit}) {
    const items = reactive(props.modelValue || []);
    let form;

    const reset = () => {
      form = reactive({...props.model});
    };

    const add = () => {
      items.push(form);
      emit('add', form);
      sync();
      reset();
    };

    const remove = (item) => {
      items.splice(items.indexOf(item), 1);
      sync();
    };

    const sync = () => {
      emit('update:modelValue', items);
    }

    reset();

    return {
      get form(){
        return form;
      },
      add,
      remove,
      items
    }
  }
}
</script>
